/**
 * Single error→user-message choke point (V32 root cause 2).
 *
 * Pages must render errors via `getErrorMessage(...)` instead of
 * `(error as Error).message` so parse errors, network failures and
 * backend internals can never reach an operator's screen.
 */
export const FRIENDLY_FALLBACK_MESSAGE = "Something went wrong. Please try again.";

/** Errors whose `.message` is technical noise rather than a user-facing string. */
function isTechnicalError(error: Error): boolean {
  return (
    error instanceof SyntaxError || // JSON.parse leftovers
    error instanceof TypeError || // fetch/network failures ("Failed to fetch")
    error.name === "AbortError"
  );
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error && !isTechnicalError(error) && error.message.trim()) {
    return error.message;
  }
  return FRIENDLY_FALLBACK_MESSAGE;
}
